import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper d-flex flex-column" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-100 flex-fill",
  id: "googleMap"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _hoisted_3
  ]))
}